module.exports = __webpack_public_path__ + "img/patch-img.d44df3d6.png";